<template>
    <div id="culture_wrapper" class="scroller">
        <div id="culture" class="position-relative">
            <div class="stipple-bg">
                <TickerTextCulture class="d-md-block d-none"/>
                <b-container>
                    <section class="top-spacer-culture"></section>
                    <b-row class="">
                        <b-col md="4" class="d-flex">
                            <div class="fade-in-up-element overflow-hidden position-relative skewElem" style="z-index: 10">
                                <img src="/img/vibes/vibes-georgie.jpg" alt="Georgie" class="w-100 d-md-block d-none plax-img">
                            </div>
                            <div class="overflow-hidden position-relative skewElem" style="z-index: 10">
                                <img src="/img/vibes/vibes-georgie.jpg" alt="Georgie" class="w-100 d-block d-md-none">
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-300">
                        <b-col cols="9">
                            <div class="position-relative">
                                <div class="fade-in-up-element overflow-hidden skewElem mt-md-0 mt-sm-5" style="z-index: 14">
                                    <img src="/img/vibes/vibes-2.jpg" alt="Book reading" class="w-100 d-block plax-img ">
                                </div>
                                <img src="/img/guidelines-circular-stamp-pink.png" alt="Guidelines 1063" class="ga-circular-stamp fade-in-up-element"
                                width="280"
                                height="282">
                            </div>
                        </b-col>
                        <b-col cols="3" class="pl-md-5 d-md-flex flex-column justify-content-end">
                            <div class="fade-in-up-element mb-4 zIndex-10 skewElem mt-md-0 mt-sm-5 position-relative d-md-block d-none">
                                <img src="/img/vibes/vibes-3.jpg" alt="Couple on bike" class="w-100 max-w-240 d-block" data-lag="0.25">
                            </div>
                            <div class="fade-in-up-element mb-4 zIndex-10 mt-md-0 mt-sm-5 position-relative d-md-none d-block">
                                <img src="/img/vibes/vibes-3.jpg" alt="Couple on bike" class="w-100 max-w-240 d-block">
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
            <div class="stipple-bg pt-100" id="ending">
                <div class="pt-110 bg-black zIndex-21 position-relative">
                    <b-container class="pb-4">
                        <p class="gotham-book ga-pink">1063/</p>
                        <p class="h4 ga-pink">1063 urban dictionary</p>
                        <UrbanDictionarySlider />
                    </b-container>
                    <b-row>
                        <b-col cols="3" class="px-0">
                            <video src="/videos/culture-long-weekend.mp4" loop autoplay playsinline muted class="w-100 object-fit-cover d-block"></video>
                        </b-col>
                        <b-col cols="3" class="px-0">
                            <video src="/videos/culture-bar-cart.mp4" loop autoplay playsinline muted class="w-100 object-fit-cover d-block"></video>
                        </b-col>
                        <b-col cols="3" class="px-0">
                            <video src="/videos/culture-bar-cart-2.mp4" loop autoplay playsinline muted class="w-100 object-fit-cover d-block"></video>
                        </b-col>
                        <b-col cols="3" class="px-0">
                            <video src="/videos/culture-freeze-pop.mp4" loop autoplay playsinline muted class="w-100 object-fit-cover d-block"></video>
                        </b-col>
                    </b-row>
                </div>
                <b-container fluid class="pt-100">
                    <div class="px-5">
                        <p class="gotham-book h2">
                            We're pretty chill. Which isn't what you'd expect from over 40 years of award-winning work. We've got Bar-Cart Fridays, movie night, costume days, Club 1063, and most of all, the best people. It's this beautiful culture that's made this place so special to us all.
                        </p>
                    </div>
                    <b-container>
                        <b-row class="px-md-5 mt-100">
                            <b-col cols="6" class="d-md-flex flex-column">
                                <div class="fade-in-up-element overflow-hidden h-100">
                                    <img src="/img/pizza.jpg" alt="Cheers party" class="w-100 d-block max-w-400">
                                </div>
                                <div class="fade-in-up-element overflow-hidden h-100 mt-80 d-md-block d-none">
                                    <img src="/img/vibes/vibes-4.jpg" alt="Playing Guitar" class="w-100 d-block plax-img max-w-400 h-160">
                                </div>
                            </b-col>
                            <b-col cols="6" class="d-md-flex flex-column justify-content-end">
                                <div class="position-relative">
                                    <div class="gotham-book max-w-360 text-overlay">
                                        <nuxt-img 
                                            loading="lazy" 
                                            provider="static" 
                                            format="webp"
                                            src="/img/quotes-left.png" 
                                            alt="Quotations"
                                            class="d-block max-w-40"
                                            width="40"
                                            height="31"
                                            sizes="lg:41px"
                                        />
                                        <p class="h4 mt-4 gotham-book">
                                            Yes, this is a
                                            <br>
                                            place of business
                                        </p>
                                        <div class="d-flex justify-content-between">
                                            <nuxt-img 
                                                loading="lazy" 
                                                provider="static" 
                                                format="webp"
                                                src="/img/quotes-right.png" 
                                                alt="Quotations"
                                                class="d-block max-w-40 w-100 h-100 ml-auto"
                                                width="40"
                                                height="31"
                                                sizes="lg:41px"
                                            />
                                        </div>
                                    </div>
                                    <div class="overflow-hidden fade-in-up-element">
                                        <img src="/img/val-office.jpg" alt="Office with figure collection" class="w-100 d-block max-w-460 h-160">
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-container>
            </div>
            <!--  -->
            <div class="stipple-bg conclusion pt-5">
                <div>
                    <b-container class="mt-50">
                        <b-row>
                            <b-col cols="6" class="d-md-flex flex-column">
                                <div class="fade-in-up-element ml-md-auto position-relative mr-md-5 pr-md-5">
                                    <div class="overflow-hidden plax-img">
                                        <img src="/img/culture-icecream.jpg" alt="Ice Cream" class="w-100 d-block plax-img max-w-280 h-130 skewElem">
                                    </div>
                                    <img src="/img/guidelines-circular-stamp-pink.png" alt="Guidelines 1063" class="ga-circular-stamp-2"
                                    width="280"
                                    height="282">
                                </div>
                            </b-col>
                            <b-col cols="6">
                                <div class="fade-in-up-element overflow-hidden h-70 skewElem">
                                    <img src="/img/culture-walk.jpg" alt="Team having a walk" class="w-100 d-block plax-img max-w-500 h-140 skewElem">
                                </div>
                                <div class="fade-in-up-element mt-5">
                            </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </div>
            <Transition1063 />
            <AppFooter />
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    data() {
        return {
            scrollSmoother_culture: null,
            textAnimation_culture: null,
            fadeInUpElement_culture: null
        }
    },
    components: {
        TickerTextCulture: () => import('@/components/TickerTextCulture'),
        Transition1063: () => import('@/components/Transition1063'),
        UrbanDictionarySlider: () => import('@/components/UrbanDictionarySlider'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            this.initscrollSmoother_culturePage();
            this.initImgElReveal_culturePage();
            // this.initImageSkewOnScroll_culturePage();
        }, 500)
    },
    methods: {
        initscrollSmoother_culturePage() {
            this.scrollSmoother_culture = ScrollSmoother.create({
                wrapper: '#culture_wrapper',
                content: "#culture",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_culture.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_culturePage() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_culture = this.fadeInUpElement_culture;
                fadeInUpElement_culture = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_culture.set(container, { autoAlpha: 1 });
                fadeInUpElement_culture.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initImageSkewOnScroll_culturePage() {
            let proxy = { skew: 0 },
            skewSetter = gsap.quickSetter(".skewElem", "skewY", "deg"), // fast
            clamp = gsap.utils.clamp(-5, 5); // don't let the skew go beyond 20 degrees. 

            ScrollTrigger.create({
                onUpdate: (self) => {
                    let skew = clamp(self.getVelocity() / -500);
                    // only do something if the skew is MORE severe. Remember, we're always tweening back to 0, so if the user slows their scrolling quickly, it's more natural to just let the tween handle that smoothly rather than jumping to the smaller skew.
                    if (Math.abs(skew) > Math.abs(proxy.skew)) {
                    proxy.skew = skew;
                    gsap.to(proxy, {skew: 0, duration: 1.5, ease: "power3", overwrite: true, onUpdate: () => skewSetter(proxy.skew)});
                    }
                }
            });
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            // this.scrollSmoother_culture.kill()
            ScrollTrigger.getAll().forEach(t => t.kill());

        }, 500)
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables';

#culture {

    .top-spacer-culture {
        height: 600px;

        @media screen and (max-width: 991px) {
            height: 200px;
        }
    }

    .ga-circular-stamp {
        position: absolute;
        right: -110px;
        top: -160px;
        width: 100%;
        max-width: 280px;
        z-index: 1;
    }

    .ga-circular-stamp-2 {
        position: absolute;
        left: -190px;
        bottom: -162px;
        width: 100%;
        max-width: 280px;
    }
      

    .zIndex-10 {
        z-index: 10;
    }

    .zIndex-12 {
        z-index: 12;
    }

    .zIndex-16 {
        z-index: 16;
    }

    .zIndex-21 {
        z-index: 21;
    }

    .mt-300 {
        @media screen and (max-width: 991px) {
            margin-top: 140px;
        }
    }

    .text-overlay {
        position: absolute;
        top: -60px;
        left: -50px;
        z-index: 4;

        @media screen and (max-width: 991px) {
            display: none;
        }
    }
}



</style>